const norm = (s) => (s || "").trim().toLowerCase();

// 40 shared interests + 30 faith + 30 openness to (international) match
export function compatibility(me, p) {
  if (!me || !p || me.id === p.id) return null;
  const a = new Set((me.interests || []).map(norm));
  const b = (p.interests || []).map(norm);
  const shared = b.filter((x) => a.has(x)).length;
  const interestScore = a.size && b.length ? Math.round((40 * shared) / Math.min(a.size, b.length)) : 15;
  const faith = norm(me.religion) === norm(p.religion) ? 30 : 12;
  const sameCountry = (me.country || "India") === (p.country || "India");
  const both = me.open_to_international !== false && p.open_to_international !== false;
  const open = sameCountry ? 30 : both ? 30 : me.open_to_international !== false || p.open_to_international !== false ? 12 : 0;
  return Math.min(99, Math.max(20, interestScore + faith + open));
}

export const crossBorder = (me, p) => !!me && !!p && (me.country || "India") !== (p.country || "India");
